import { assign } from 'xstate';
import { PaymentContext } from '../../../types';

export const incrementCancelRetryCount = assign<PaymentContext>(
    { cancelRetryCount: (context, _: any) => context.cancelRetryCount + 1 }
)